import { ExperienceByUserId } from "../models/Experience";
import { AuthStore } from "../store/Auth";
import serviceFetch from "./helpers";

export const getExperiencesByUserId = async (
  uid: string,
  auth: AuthStore
): Promise<ExperienceByUserId> =>
  serviceFetch(auth, `proxy/experiences/user/${uid}`, null, "get");
